import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function acquaitanceReducer() {
    return combineReducers({
        ReceiveSysDoc_TreeDocForPO: createItemReducer("ReceiveSysDoc", "ReceiveSysDoc.TreeDocForPO", false),
        ReceiveSysDoc_TreeDocForPOParams: createItemReducerParams("ReceiveSysDoc", "ReceiveSysDoc.TreeDocForPO")
    });
}